import React from 'react';
import glamorous from 'glamorous';
import { RadioButton } from 'react-toolbox/lib/radio';
import { orderSort } from '../../index';

export const RadioGroup = ({
  onChange,
  disabled,
  value,
  children,
  // eslint-disable-next-line no-unused-vars
  error,
  ...restProps
}) => {
  return (
    <div {...restProps}>
      {React.Children.map(children, child => {
        return React.cloneElement(child, {
          onChange: e => onChange(e.target.value),
          disabled,
          checked: value === child.props.value,
        });
      })}
    </div>
  );
};

export const RadioGroupContainer = glamorous(RadioGroup, {})({
  padding: '1.2rem 1rem',
  '& > label:first-child': {
    marginTop: '1.5rem',
  },
});

const CustomRadio = glamorous(RadioButton, {
  rootEl: 'input',
  forwardProps: [
    'checked',
    'className',
    'disabled',
    'label',
    'name',
    'onBlur',
    'onChange',
    'onFocus',
    'value',
  ],
})(({ checked, color }) => {
  let checkedStyle = {};
  if (checked) {
    checkedStyle = { borderColor: color };
  }
  return {
    '& > div': {
      ...checkedStyle,
      ':before': {
        backgroundColor: `${color} !important`,
      },
      '& > span:last-child > span': {
        backgroundColor: `${color} !important`,
      },
    },
  };
});

export const RadioList = ({
  options = [],
  value,
  onChange,
  color,
  ...restProps
}) => {
  return (
    <RadioGroupContainer value={value} onChange={onChange} {...restProps}>
      {options.sort(orderSort).map(({ text }, i) => {
        if (typeof text !== 'string' || typeof text === 'number') {
          return <h4 key={text}>Unsupported response type</h4>;
        }
        return (
          <CustomRadio
            key={`${text}_${i}`}
            label={text}
            value={text}
            color={color}
          />
        );
      })}
    </RadioGroupContainer>
  );
};

export default RadioList;



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/QuestionGroup/InputTypes/RadioList/index.js